import React from "react";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div>
      <p className="spinner"></p>
    </div>
  );
};

export default Spinner;
